module.exports = __webpack_public_path__ + "ecd25f4628c631a2876a53345e45f1f0.png";